import { Component, ElementRef, ViewChild } from '@angular/core';
import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';

type MensajeIA = { role: 'user' | 'assistant'; text: string };

@Component({ selector: 'chat-widget', templateUrl: 'chat-widget.html' })
export class ChatWidgetComponent {
  @ViewChild('panelMensajesIA') mensajesIAElement: ElementRef;
  abierto = false;
  consultando = false;
  analizandoMes = false;
  pregunta = '';
  errorEstudio = '';
  trabajadorIASeleccionado = '';
  mensajesIA: MensajeIA[] = [
    { role: 'assistant', text: 'Hola. Soy el asistente de Control Laboral. Pregúntame sobre el panel, las picadas o el registro de jornada.' }
  ];
  telefono = '34630438995';
  emailSoporte = 'tecnico@tricenter.net';
  mensaje = '';
  private LS_KEY_MSG = 'chatWidget:mensaje';
  private LS_KEY_OPEN = 'chatWidget:abierto';

  constructor(public variablesglobales: VariablesProvider, public funciones: FuncionesProvider) {
    this.mensaje = 'Cliente: ' + (this.variablesglobales.CLIENTES_RAZSOCIAL || '') + '\n';
    if (typeof localStorage !== 'undefined') {
      const msg = localStorage.getItem(this.LS_KEY_MSG);
      if (msg) { this.mensaje = msg; }
      this.abierto = localStorage.getItem(this.LS_KEY_OPEN) === '1';
    }
    this.trabajadorIASeleccionado = this.variablesglobales.CODIGOTRABAJADOR || '';
  }

  get trabajadoresIA(): any[] {
    return Array.isArray(this.variablesglobales.TRABAJADORES_IA) ? this.variablesglobales.TRABAJADORES_IA : [];
  }

  get nombreTrabajadorSeleccionado(): string {
    const trabajador = this.trabajadoresIA.find(t => String(t.CODIGO) === String(this.trabajadorIASeleccionado));
    return trabajador ? (trabajador.NOMBRE || trabajador.CODIGO) : this.trabajadorIASeleccionado;
  }

  toggle() {
    this.abierto = !this.abierto;
    if (typeof localStorage !== 'undefined') { localStorage.setItem(this.LS_KEY_OPEN, this.abierto ? '1' : '0'); }
    if (this.abierto) { this.scrollMensajes(); }
  }

  preguntarIA() {
    const q = (this.pregunta || '').trim();
    if (!q || this.consultando) { return; }
    this.pregunta = '';
    this.consultar(q, null);
  }

  private consultar(q: string, estudio: any): void {
    this.mensajesIA.push({ role: 'user', text: q });
    this.consultando = true;
    this.scrollMensajes();
    const historial = this.mensajesIA.slice(Math.max(0, this.mensajesIA.length - 8));
    Promise.resolve(this.funciones.preguntaAgenteIA(q, historial, estudio)).then((data: any) => {
      let respuesta: any = Array.isArray(data) ? (data[0] || {}) : data;
      const texto = respuesta && (respuesta.respuesta || respuesta.answer || respuesta.output_text || respuesta.mensaje);
      this.mensajesIA.push({ role: 'assistant', text: texto || 'No he podido obtener una respuesta. Puedes continuar por WhatsApp o email.' });
    }).catch(() => {
      this.mensajesIA.push({ role: 'assistant', text: 'El asistente no está disponible ahora. Puedes continuar por WhatsApp o email.' });
    }).then(() => { this.consultando = false; this.scrollMensajes(); });
  }

  sugerir(texto: string) { this.pregunta = texto; this.preguntarIA(); }

  seleccionarTrabajador(codigo: string): void {
    this.trabajadorIASeleccionado = codigo || '';
    this.errorEstudio = '';
  }

  async analizarMesIA(): Promise<void> {
    if (this.consultando || this.analizandoMes) { return; }
    const codigo = String(this.trabajadorIASeleccionado || '').trim();
    const trabajador = this.trabajadoresIA.find(t => String(t.CODIGO) === codigo);
    if (!codigo || !trabajador) { this.errorEstudio = 'Selecciona primero un trabajador de la lista.'; return; }
    const periodo = this.periodoActual();
    const pregunta = this.pregunta.trim() || ('Examina el mes de ' + (trabajador.NOMBRE || codigo) +
      ' y guíame con todos los fallos que encuentres. Indica la fecha, la evidencia y una solución propuesta sin modificar nada.');
    this.pregunta = '';
    this.mensajesIA.push({ role: 'user', text: pregunta });
    this.consultando = true;
    this.analizandoMes = true;
    this.errorEstudio = '';
    this.scrollMensajes();
    try {
      const informe = await this.conTimeout(this.funciones.obtieneinforme(codigo, '654321123456', '654321123456',
        '654321123456', periodo.inicio, periodo.fin, 'real'), 30000);
      const picajes = await this.cargarPicajes(codigo, periodo);
      const estudio = this.prepararEstudio(trabajador, periodo, informe, picajes);
      const historial = this.mensajesIA.slice(Math.max(0, this.mensajesIA.length - 8));
      const data = await this.funciones.preguntaAgenteIA(pregunta, historial, estudio);
      const respuesta: any = Array.isArray(data) ? (data[0] || {}) : data;
      this.mensajesIA.push({ role: 'assistant', text: (respuesta && respuesta.respuesta) || 'No he podido preparar el estudio. Puedes intentarlo de nuevo.' });
    } catch (error) {
      this.mensajesIA.push({ role: 'assistant', text: 'No he podido cargar todos los datos del mes. Revisa la conexión e inténtalo de nuevo.' });
    } finally {
      this.consultando = false;
      this.analizandoMes = false;
      this.scrollMensajes();
    }
  }

  private periodoActual(): any {
    const base = /^\d{4}-\d{2}-\d{2}$/.test(String(this.variablesglobales.DIA || '')) ? String(this.variablesglobales.DIA) : new Date().toISOString().substr(0, 10);
    const year = Number(base.substr(0, 4));
    const month = Number(base.substr(5, 2));
    const ultimo = new Date(year, month, 0).getDate();
    const dos = (n: number) => n < 10 ? '0' + n : String(n);
    return { mes: year + '-' + dos(month), inicio: year + '-' + dos(month) + '-01', fin: year + '-' + dos(month) + '-' + dos(ultimo) };
  }

  private async cargarPicajes(codigo: string, periodo: any): Promise<any[]> {
    const inicio = Date.parse(periodo.inicio + 'T00:00:00Z');
    const fin = Date.parse(periodo.fin + 'T00:00:00Z') + 86400000;
    const fechas: string[] = [];
    for (let t = inicio - 2 * 86400000; t < fin + 2 * 86400000; t += 86400000) {
      const d = new Date(t); const dos = (n: number) => n < 10 ? '0' + n : String(n);
      fechas.push(d.getUTCFullYear() + '-' + dos(d.getUTCMonth() + 1) + '-' + dos(d.getUTCDate()));
    }
    const resultado: any[] = [];
    for (let i = 0; i < fechas.length; i += 6) {
      const lote = await Promise.all(fechas.slice(i, i + 6).map(fecha => this.conTimeout(this.funciones.obtienepicajesdesc(codigo, fecha), 8000, [])));
      lote.forEach(filas => (Array.isArray(filas) ? filas : []).forEach(p => resultado.push(p)));
    }
    return resultado;
  }

  private prepararEstudio(trabajador: any, periodo: any, informe: any, picajes: any[]): any {
    const campos = ['FECHA', 'DIA', 'NOMBRE', 'PICADA_INICIAL', 'PICADA_FINAL', 'HORA_ENTRADA', 'HORA_SALIDA',
      'HORAS_PREVISTAS', 'HORAS_TRABAJADAS', 'HORAS_EXTRAS', 'HORAS_PARADAS', 'HORAS_SIN_TRABAJAR',
      'HORAS_ALMORZANDO', 'PICO', 'INCIDENCIA', 'TIPO'];
    const filas = (Array.isArray(informe) ? informe : []).map(fila => {
      const salida: any = {}; campos.forEach(campo => { if (fila && fila[campo] !== undefined) { salida[campo] = fila[campo]; } }); return salida;
    });
    const registros = (Array.isArray(picajes) ? picajes : []).map(p => ({ FECHA: p && p.FECHA, HORA: p && (p.HORA || p.PICADA), SENTIDO: p && p.SENTIDO, OBRA: p && p.OBRA }));
    return { tipo: 'estudio_mensual_picadas_solo_lectura', trabajador: { CODIGO: trabajador.CODIGO, NOMBRE: trabajador.NOMBRE,
      TURNO: trabajador.TURNO, HORAS_CONTRATO: trabajador.HORAS_CONTRATO }, periodo: periodo, resumenDiario: filas, picadas: registros };
  }

  private conTimeout<T>(promesa: Promise<T>, milisegundos: number, valorSiCaduca?: T): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      let terminado = false;
      const timer = setTimeout(() => { if (terminado) { return; } terminado = true; if (valorSiCaduca !== undefined) { resolve(valorSiCaduca); } else { reject(new Error('La consulta ha tardado demasiado.')); } }, milisegundos);
      promesa.then(valor => { if (terminado) { return; } terminado = true; clearTimeout(timer); resolve(valor); }, error => { if (terminado) { return; } terminado = true; clearTimeout(timer); reject(error); });
    });
  }

  private scrollMensajes(): void {
    setTimeout(() => { const elemento: any = this.mensajesIAElement && this.mensajesIAElement.nativeElement; if (elemento) { elemento.scrollTop = elemento.scrollHeight; } }, 40);
  }

  append(texto: string) { this.mensaje = this.mensaje ? (this.mensaje + ' | ' + texto) : texto; this.guardarMensaje(this.mensaje); }
  guardarMensaje(valor: string) { if (typeof localStorage !== 'undefined') { localStorage.setItem(this.LS_KEY_MSG, valor || ''); } }
  waLink(): string { return 'https://wa.me/' + this.telefono + '?text=' + encodeURIComponent(this.mensaje); }
  mailLink(): string { return 'mailto:' + this.emailSoporte + '?subject=' + encodeURIComponent('Contacto desde Control Laboral') + '&body=' + encodeURIComponent(this.mensaje); }
}



// WEBPACK FOOTER //
// ./src/components/chat-widget/chat-widget.ts